import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/theme.css";
import "./styles/notify.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { THEME } from "./styles/colors";
import { UserProvider } from "./context/UserContext";
import { configureNotifications } from "./helper/notify";

// Consistent placement/timing for all toasts across the product.
configureNotifications();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: '"Poppins", sans-serif',
          colorPrimary: THEME.primary,
          colorInfo: THEME.secondary,
          colorTextBase: THEME.text,
          colorText: THEME.text,
          colorTextSecondary: THEME.tableMuted,
          colorTextDescription: THEME.tableMuted,
          colorBorder: "rgba(45, 55, 72, 0.14)",
          colorBorderSecondary: "rgba(108, 138, 155, 0.35)",
          colorFillAlter: THEME.surface,
          colorBgLayout: THEME.surface,
          colorBgContainer: THEME.surface,
          colorBgElevated: "#ffffff",
          controlItemBgHover: "rgba(11, 31, 58, 0.06)",
          controlOutline: `rgba(11, 31, 58, 0.18)`,
        },
        components: {
          Layout: {
            bodyBg: THEME.surface,
            headerBg: THEME.primary,
            triggerBg: THEME.primary,
          },
          Menu: {
            darkItemBg: THEME.primary,
            darkItemSelectedBg: THEME.secondary,
            darkSubMenuItemBg: THEME.primary,
            darkItemHoverBg: "rgba(17, 43, 76, 0.85)",
          },
          Table: {
            headerBg: THEME.secondary,
            headerColor: THEME.surface,
            headerSplitColor: "rgba(242, 244, 247, 0.2)",
            borderColor: "rgba(108, 138, 155, 0.45)",
            rowHoverBg: "rgba(108, 138, 155, 0.14)",
          },
          Card: {
            colorBgContainer: THEME.surface,
            colorBorderSecondary: "rgba(45, 55, 72, 0.1)",
          },
          Button: {
            primaryShadow: "0 2px 0 rgba(11, 31, 58, 0.06)",
          },
        },
      }}
    >
      <BrowserRouter>
        {/* UserProvider wraps the whole app so useUser() works everywhere */}
        <UserProvider>
          <App />
        </UserProvider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>,
);

reportWebVitals();
